export default __webpack_public_path__ + "static/media/H.G.Nadun_Dilshan_CV.fcfea027.pdf";